import { render, staticRenderFns } from "./ArgentinaLotteryBoard.vue?vue&type=template&id=278f12eb&scoped=true&"
import script from "./ArgentinaLotteryBoard.vue?vue&type=script&lang=js&"
export * from "./ArgentinaLotteryBoard.vue?vue&type=script&lang=js&"
import style0 from "./ArgentinaLotteryBoard.vue?vue&type=style&index=0&id=278f12eb&scoped=true&lang=css&"
import style1 from "./ArgentinaLotteryBoard.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278f12eb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VFlex,VImg,VRow})
